module.exports = __webpack_public_path__ + "img/53.689c208e.png";